import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { AgEditorComponent } from '../../../../global/gx-ag-grid/ag-editor.component';
import { Location } from '../../../../../models/locations-models/location';
import { FeedbackService } from '../../../../../core/feedback.service';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ICellEditorParams } from 'ag-grid-community';
import { StatusTControl } from '../../../../../models/locations-models/edit-location-form';
import { LSCField } from '../../../../../models/LSCFields';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-status-editor',
    templateUrl: './status-editor.component.html',
    styleUrl: './status-editor.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [LetDirective, CdkTrapFocus, FormsModule, ReactiveFormsModule, MatButtonToggleGroup, MatButtonToggle]
})
export class StatusEditorComponent extends AgEditorComponent<Location>{
  @ViewChild('buttonToggle') buttonToggle: MatButtonToggle;

  protected readonly LSCField = LSCField;

  constructor(protected feedbackService: FeedbackService,
              protected cd: ChangeDetectorRef,
              private fb: FormBuilder) {
    super(feedbackService, cd);
  }

  protected override createEditorFormGroup(params: ICellEditorParams<Location>): FormGroup<StatusTControl> {
    return this.fb.group(
        {
          'businessStatus': [params?.data?.businessStatus, [Validators.required]],
          'managementStatus': [params?.data?.managementStatus, [Validators.required]],
        },
    );
  }

  /**
   * Return the new location field value
   * Override in child component if needed
   * @protected
   */
  protected override getNewFieldValue() {
    return {
      [LSCField.businessStatus]: this.editorFormGroup.get(LSCField.businessStatus).value,
      [LSCField.managementStatus]: this.editorFormGroup.get(LSCField.managementStatus).value
    }
  };

  /**
   * A hook to perform any necessary operation just after the GUI for this component has been
   * rendered on the screen.
   * This method is called each time the edit component is activated.
   * This is useful for any logic that requires attachment before executing, such as putting focus
   * on a particular DOM element.
   */
  afterGuiAttached(): void {
    this.buttonToggle?.focus();
  }
}
